import type { FaireProductEntity } from "../../entity_types/product";

export const p_qd3wazsrwy: FaireProductEntity = {
  token: "p_qd3wazsrwy",
  type: "product",
  name: "Heirloom Tomato Beeswax Candle",
  brandToken: "b_5fqncx9pfy",
  brandName: "Artifaqt",
  imageUrl:
    "https://cdn.faire.com/fastly/bf7bc6b932d3e855f72e63dc88193a891ba7dec07a48c9686762c356d8da2ff7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6615ec693d63db39edf2618ae8081362ab66901a21f472abbc0dc607c940b29d.jpeg",
    "https://cdn.faire.com/fastly/99c78a607159066fdf5b6012bb4714b518f1f47008ab0a567deb730712f0a813.jpeg",
    "https://cdn.faire.com/fastly/bb386a0d7913c002e2ff904f9d8f7a4047940a99670dd06fab246c22b5dedab8.jpeg",
    "https://cdn.faire.com/fastly/9136367a4c6d8646d4aa1a631defe33782cf41aed0b72b3103c23c90842fb208.jpeg",
    "https://cdn.faire.com/fastly/3ee73c5d99aeb62b8d15ca6cfcbf894ddce1098c9bb494a86efcc062d3155adb.jpeg",
    "https://cdn.faire.com/fastly/54d514bdf101cf2eefba87ce9c9d0c27fd2db86cced547ff0447d15205ad9503.jpeg",
    "https://cdn.faire.com/fastly/54d858aa60998ecdc218c6859a837e49e7b666f583d20cb53827932bf24de6cb.jpeg",
    "https://cdn.faire.com/fastly/7d08976046c90ab6f371cda29cd2a181be43e29ec60513bf63d4328ee37ad412.jpeg",
  ],
  priceDollars: 16.5,
  description:
    "FIRST TIME BUYERS must message Artifaqt BEFORE placing an order. Please provide your web/social information. Thank you! \n\nEmma from Kneehigh Farm let me walk through her impressively packed tomato tunnels in search for the perfect unripe heirloom. With hundreds of tomatoes to choose from, I don’t think I could have gone wrong! We are very pleased with the final result, both in terms of appearance and how these candles burn! \n\nThe beeswax used in these candles in sourced from Swarmbustin’ Honey in Chester County. Swarmbustin’ also cares for the pollinating hives on Kneehigh’s farm. These candles are a true collaboration between the bees, the beekeepers, the badass farmers of Kneehigh and the mold makers of Artifaqt!\n\nBeeswax naturally burns cleaner, brighter, hotter, and longer than most choices and does not require chemical processing or additives to enhance these properties. With an inherently pleasant but gentle aroma, beeswax is the perfect choice for the eco-conscious home.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:04:00.018Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
